import React, { useEffect } from 'react';
import './PrivacyPolicy.css';
import logo from './assets/logo.webp';

function PrivacyPolicy() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Privacy Policy | Spyyda Tech Solutions LLP';
    window.scrollTo(0, 0);
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="pp-page">
      <header className="pp-header">
        <a href="/" aria-label="Back to Spyyda Tech Solutions home">
          <img src={logo} alt="Spyyda Tech Solutions" className="pp-logo" />
        </a>
        <a href="/" className="pp-back">&larr; Back to website</a>
      </header>

      <main className="pp-container">
        <h1>Privacy Policy &mdash; Spyyda Tech Solutions LLP</h1>
        <p className="pp-updated">Last updated: September 2026</p>

        <p>
          SpyydaOps Publisher (&ldquo;the App&rdquo;) is operated by Spyyda Tech
          Solutions LLP.
        </p>

        <section>
          <h2>What data we access</h2>
          <ul>
            <li>Instagram Business Account information (account ID, profile details)</li>
            <li>Permission to publish content (images, reels, carousels) on your behalf</li>
            <li>Campaign performance metrics (impressions, reach, clicks, spend)</li>
          </ul>
        </section>

        <section>
          <h2>How we use it</h2>
          <ul>
            <li>
              To automatically publish scheduled content from SpyydaOps to your
              Instagram Business account
            </li>
            <li>
              To retrieve campaign performance data for reporting within SpyydaOps
            </li>
            <li>We do not sell, share, or transfer your data to any third party</li>
          </ul>
        </section>

        <section>
          <h2>Data storage</h2>
          <ul>
            <li>Access tokens are stored securely in our Firebase database</li>
            <li>We retain data only as long as needed to provide the service</li>
            <li>
              You can revoke access at any time by disconnecting your account in
              SpyydaOps or removing our app from your Meta Business Settings
            </li>
          </ul>
        </section>

        <section>
          <h2>Contact</h2>
          <address>
            Spyyda Tech Solutions LLP<br />
            2nd Floor, 78, Kongu Nagar, Ramanathapuram,<br />
            Coimbatore, Tamil Nadu 641045<br />
            Email: <a href="mailto:spyydadesk@spyydatech.com">spyydadesk@spyydatech.com</a><br />
            Phone: <a href="tel:+919514146499">+91 95 14 14 64 99</a>
          </address>
        </section>
      </main>

      <footer className="pp-footer">
        <p>&copy; {new Date().getFullYear()} Spyyda Tech Solutions LLP. All rights reserved.</p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;
